import { fetchApi } from 'Utils/utils';

const URL_PREFIX = '/api/v1/reports/customerOrder';

const customerOrderCountReport = function(params) {
  return fetchApi.post(`${URL_PREFIX}/count/`, params);
};

const customerOrderDetailedReport = function(params) {
  return fetchApi.post(`${URL_PREFIX}/details/`, params);
};

const findRecentOrders = function(customerId, wplusCustomerId) {
  return fetchApi.get(`${URL_PREFIX}/recentOrders/${customerId}/${wplusCustomerId}/`);
};

export { customerOrderCountReport, customerOrderDetailedReport, findRecentOrders };
